import Site from 'stores/Site'

import Page from 'classes/Page'

export default class Home extends Page {
    constructor() {
        super()
    }

    init() {
        super.init()

        this.initHero()
    }

    initHero() {
        const section = Site.page.querySelector('.s-hero')
        const texts = section.querySelectorAll('.top-text')
        let current = 0

        setInterval(() => {
            texts.forEach(el => {
                el.classList.remove('active')
            })

            if (current === texts.length - 1) {
                current = 0
            } else {
                current++
            }

            setTimeout(()=> {
                texts[current].classList.add('active')
            }, 100)
        }, 2500)
    }

    onResize() {
        super.onResize()
    }

    onScroll() {
        super.onScroll()
    }
}